<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :landscapingActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "Landscaping",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "landscaping/IMG-20170827-WA0004.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "landscaping/IMG-20170906-WA0004.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Landscaping",
    serviceDescription: "Paving walks ways and drive ways, yard landscaping."
  })
};
</script>
